import React from 'react';
import styled from 'styled-components';

const FormInputText = styled.input`
  width: 100%;
  background-color: #ffffff;
  padding: 12px 8px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: -1px;
  color: #000000;
  min-height: 48px;
  border-radius: 1px;
  box-sizing: border-box;
  border: solid 1px #E1E3E2;
  ${props => props.border && 'border-color: #e0e0e0'};
  :focus {
    outline: none;
  }
  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #bbbcbc;
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #bbbcbc;
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #bbbcbc;
  }
  
  :-webkit-autofill { 
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    -webkit-text-fill-color: #767676;
  }
  :-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    -webkit-text-fill-color: #767676;
    outline: none;
  }
  ${props => props.error && 'border-color: #dd4124;'}
`;

const FormValidateMessage = styled.div`
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #dd4124;
  margin-top: 6px;
`;


class FormInput extends React.Component {
  render() {
    const {
      name,
      value,
      placeholder,
      onChange,
      errorMsg,
      fireSubmitValidation,
      type,
      onBlur,
      maxLength,
      border,
      autoCapitalize,
    } = this.props;

    const error = errorMsg || (fireSubmitValidation && !value) || '';

    return (
      <React.Fragment>
        <FormInputText
          type={type || 'text'}
          name={name}
          onChange={onChange}
          value={value}
          placeholder={placeholder}
          autoComplete="off"
          error={error}
          onBlur={onBlur}
          maxLength={maxLength || ''}
          border={border}
          autoCapitalize={autoCapitalize || 'none'}
          autocorrect="off"
          {...this.props}
        />
        {fireSubmitValidation &&
          !value && <FormValidateMessage>필수 정보입니다</FormValidateMessage>}
        {!fireSubmitValidation &&
          errorMsg && <FormValidateMessage>{errorMsg}</FormValidateMessage>}
      </React.Fragment>
    );
  }
}

export default FormInput;
